export default {
  facebook: "",
  instagram: "",
  x: "",
};
